import React from 'react';
import { styled } from '@material-ui/core';
import Container from 'reactor/components/Grid/ContainerWithWidth'
import GridItem from 'reactor/components/Grid/GridItem'
import Button from 'reactor/components/Button'
import Heading from './heading'
import Hidden from '@material-ui/core/Hidden';


export default function BreadcrumbWithImage(props) {
    const BreadcrumbStyled = styled('div') (({ theme }) => ({
        backgroundImage: props.back ? 'url(' + props.back + ')' : 'unset',
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
        backgroundColor: props.backgroundColor ?? props.backgroundColor,
        color: props.backgroundColor ? '#fff' : '#000',
        position: 'relative',
        paddingTop: '5rem',
        position: 'relative',
        [theme.breakpoints.down("959")]: {
            // minHeight: '68rem',
            backgroundImage: 'unset',
            textAlign: 'center',
        },
        [theme.breakpoints.up("xl")]: {
            backgroundSize: 'contain',
            '& .MuiGrid-container': {
                alignItems: 'center',
            }
        },
        '& .MuiGrid-item': {
            paddingBottom: '0',
        },
        '& img': {
            zIndex: '2',
            lineHeight: '0',
            // top:'3rem !important',
            [theme.breakpoints.up("1367")]: {
                // top:'-1rem !important',
            },
            // [theme.breakpoints.down("768")]: {
            //     maxWidth: '50rem',
            // },
        },
    }));

    let img = props.img;
    if(img) {
        img = <GridItem sm={6} xs={12} align="center" ><div className="hidden-xs-sm"><img src={props.img} className="img-fluid" alt=""/></div></GridItem>
    }
    return (
        <BreadcrumbStyled className="breadcrumb">
            <Container justifyContent="center">
                <GridItem md={6} xs={12}>
                    <Heading
                        title={props.text}
                        subtitle={props.subtext}
                        notify={props.content}
                    />
                    {props.button ? <Button className="order-button" text="أطلب الآن" variant="contained" background="#1BAAB3" /> : ""}
                </GridItem>
                { img }
            </Container>
        </BreadcrumbStyled>
    )
}